import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { AbsenceDetailScreen } from '@/features/hr-reports/absence-detail-screen'
import { hrReportSearchFrom } from '@/features/hr-reports/api'
import { hasGrant } from '@/lib/me'
export const Route = createFileRoute('/_authenticated/hr/reports/absence-detail')({
  validateSearch: (s: Record<string, unknown>) => hrReportSearchFrom(s),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'hr_report.view')) throw redirect({ to: '/hr' })
  },
  component: RouteScreen,
})
function RouteScreen() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <AbsenceDetailScreen
      search={search}
      onSearchChange={(next) => void navigate({ to: '/hr/reports/absence-detail', search: next })}
    />
  )
}
